"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminUpdateApproverRolesSchema = exports.adminUpdateRolesSchema = exports.adminUserListQuerySchema = exports.ADMIN_USER_STATUS_FILTER = exports.ADMIN_USER_LIST_ORDER = exports.ADMIN_USER_LIST_SORT = void 0;
const zod_1 = require("zod");
const roles_1 = require("../roles");
const common_1 = require("./common");
exports.ADMIN_USER_LIST_SORT = ['name', 'last_sign_in'];
exports.ADMIN_USER_LIST_ORDER = ['asc', 'desc'];
exports.ADMIN_USER_STATUS_FILTER = ['active', 'suspended', 'soft_deleted'];
const optionalBool = zod_1.z
    .union([zod_1.z.boolean(), zod_1.z.literal('true'), zod_1.z.literal('false')])
    .optional()
    .transform((v) => {
    if (v === undefined)
        return undefined;
    if (typeof v === 'boolean')
        return v;
    return v === 'true';
});
exports.adminUserListQuerySchema = zod_1.z
    .object({
    search: common_1.optionalTrimmedString,
    status: zod_1.z.enum(exports.ADMIN_USER_STATUS_FILTER).optional(),
    includeSoftDeleted: optionalBool,
    sort: zod_1.z.enum(exports.ADMIN_USER_LIST_SORT).optional(),
    order: zod_1.z.enum(exports.ADMIN_USER_LIST_ORDER).optional(),
})
    .strict();
exports.adminUpdateRolesSchema = zod_1.z
    .object({
    roles: zod_1.z.array(roles_1.appRoleSchema).max(9),
})
    .strict()
    .transform((value) => ({
    roles: Array.from(new Set(value.roles)),
}));
exports.adminUpdateApproverRolesSchema = zod_1.z
    .object({
    roles: zod_1.z.array(roles_1.approverRoleSchema).max(5),
})
    .strict()
    .transform((value) => ({
    roles: Array.from(new Set(value.roles)),
}));
//# sourceMappingURL=admin-users.js.map